import { Pipe, PipeTransform } from '@angular/core'
import type { CardModel } from '@flocasts/experience-service-types'
import type { FloApiSearchResponseData } from '../../../singleton-services/search-data.service.interface'
import { convertSecondsToDuration } from '../../../shared/functions/date-time'
import { mapSearchItemToDateRange } from './old-search.utility'
import { SiteIds } from '../../../shared/models/site.model'

/**
 * Pipe to transform a Core API search results to a CardModel.
 */
@Pipe({ name: 'searchItemToCardModel' })
export class SearchItemToCardModelPipe implements PipeTransform {
  public transform(
    item: FloApiSearchResponseData & { search_term: string | null },
    itemOrder: number,
    arrayLength: number,
    siteId?: number
  ): CardModel {
    return {
      type: 'card',
      id: item.id.toString(),
      style: 'large-card',
      title:
        siteId === SiteIds.VARSITY && item.type === 'team'
          ? item.long_name
            ? item.long_name
            : item.title
          : item.title,
      previewImage: {
        url: item.asset_url,
        style: 'standard',
        altText: item.asset.alt_text,
        type: 'image',
        id: 'non-unique-id',
        zoom: 1
      },
      iconImage: null,
      description: item.description_plain ?? null,
      label1: item.duration && item.duration > 0 ? convertSecondsToDuration(item.duration) : null,
      previewVideoMetadata: null,
      showPlayIcon: item.type === 'video',
      subtitle1: null,
      subtitle2: null,
      subtitle1Parts: {
        displayDate: mapSearchItemToDateRange(item.type, item.publish_start_date, item.start_date_time),
        type: 'node-detail-parts',
        isPremium: item.premium,
        authorName: null
      },
      action: {
        type: 'link',
        id: 'non-unique-id',
        apiCall: null,
        asset: null,
        secondaryAsset: null,
        contentMetadata: null,
        mergeParams: null,
        nextStyle: null,
        nodeId: item.node.id,
        nodeType: item.type,
        screenType: 'unknown',
        shareUrl: null,
        state: null,
        style: 'open',
        title: null,
        url: item.slug_uri,
        analytics: {
          siteName: null, // populated by Angular
          siteId: null, // populated by Angular
          type: 'analytics',
          nodeId: item.node.id,
          nodeType: item.type,
          primaryAssociationId: null,
          primaryAssociationTitle: null,
          primaryAssociationShortTitle: null,
          collectionSlug: null,
          slugUri: null,
          isPremium: item.premium,
          entityId: item.node.id,
          entityType: item.type,
          extraContext: {
            itemOrder,
            arrayLength,
            contentIds: item.aggregated_node_ids,
            categorySlugs: item.aggregated_category_slugs,
            searchTerm: item.search_term,
            searchResultType: 'search-page'
          },
          name: item.title,
          videoAnalytics: null
        }
      }
    }
  }
}
